import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { Instructions_ModuleContextService } from './Instructions.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class Instructions_instruction_types_dd_ComponentContextService {
  private readonly moduleContext: Instructions_ModuleContextService;

  constructor(moduleContext: Instructions_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'instruction_types_dd',
      type: ComponentType.selector
    }
  }
}